import PropTypes from 'prop-types';

export default PropTypes.shape({
  id: PropTypes.string.isRequired,
  customerNumber: PropTypes.string.isRequired,
  teamOrAgent: PropTypes.string.isRequired,
});
